module.exports = __webpack_public_path__ + "img/login-dark.684bd68d.svg";